<template>
  <div id="product-documents-rear-jacket-create">

    <rear-jacket-form v-model="model" :apiModel="apiModel" ref="form" />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              :disabled="loading"
              @click="$router.push({ name: 'rear-jacket.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="create()"
              class="my-4"
              color="light"
          >
            Upload
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import RearJacketForm from "@/views/pages/product-documents/rear-jacket/RearJacketForm";
import ProductDocumentCreateMixin from "@/components/mixins/ProductDocumentCreateMixin";

export default {
  name: "RearJacketCreate",
  components: {
    RearJacketForm,
  },
  mixins: [ProductDocumentCreateMixin],
  data() {
    return {
      apiModel: 'productRearJacket',
    };
  },
};
</script>

<style scoped>

</style>
